import React from 'react';

import ScoresEmptyGraph from './scores-empty-graph.png';

export default ({ className }) => (
  <img className={className} src={ScoresEmptyGraph} alt="Scores Empty Graph" />
);
